import React, { useState } from "react";

const CopyToClipboard = ({ texts, heading }) => {
  const [tooltipState, setTooltipState] = useState(
    new Array(texts.length).fill(false)
  );
  const [tooltipText, setTooltipText] = useState("");

  const handleCopyClick = (text, index) => {
    // Copy text to clipboard
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);

    // Set tooltip text and show it for the clicked text
    setTooltipText("Copied!");
    setTooltipState((prev) => {
      const newState = [...prev];
      newState[index] = true;
      return newState;
    });

    // Hide tooltip after a short delay
    setTimeout(() => {
      setTooltipState((prev) => {
        const newState = [...prev];
        newState[index] = false;
        return newState;
      });
    }, 1000);
  };

  return (
    <div className="flex flex-col gap-4">
      {heading && (
        <p className="text-sm font-semibold text-gray-700 mb-2">{heading}</p>
      )}

      <div className="flex flex-wrap gap-2">
        {texts.map((text, index) => (
          <div key={index} className="relative inline-block">
            <button
              onClick={() => handleCopyClick(text, index)}
              className="inline-flex items-center px-3 py-1.5 bg-gray-100 text-gray-800 text-xs font-medium rounded border border-gray-300 hover:bg-gray-200 transition cursor-pointer"
            >
              {text}
            </button>

            {tooltipState[index] && (
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-green-500 text-white text-xs px-2 py-1 rounded shadow-md z-10">
                {tooltipText}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CopyToClipboard;
